import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import "./Header.css";

interface Props {
    hideSearch: boolean;
    user: any;
    showSidebar: any;
    signInCreateUser({ prompt }: { prompt: boolean }): Promise<void>;
}
class Header extends React.Component<Props, {}> {
    private searchFieldForm;
    private searchField;

    public render() {
        return <div className="header-container">
            <div className="header-first-row">
                <i className="inverted bars icon large" onClick={this.props.showSidebar} />
                <div className="montserrat uppercase font-size-16 bold"><Link to='/'>Upcoming 🇺🇸</Link></div>
                <div className="login-button right floated">
                {this.props.user && this.props.user.photoURL ?
                    <img className="ui avatar image" src={this.props.user.photoURL} /> :
                    <a onClick={this.props.signInCreateUser.bind(this, { prompt: true })}><i className="ui icon user" /></a>}
                </div>
                </div>
            
            {!this.props.hideSearch && <div className="header-second-row">
                <div>
                    <form className="ui form" ref={e => this.searchFieldForm = e}>
                        <div className="ui icon input left toolbar-search-input">
                            <input type="text" name="first-name" placeholder="Search a movie" ref={e => this.searchField = e} style={{ margin: 0 }} />
                            <i className="search icon" />
                        </div>
                    </form>
                </div>
            </div>}

        </div>;
    }

    public componentDidMount() {
        if (this.searchFieldForm) {
            this.searchFieldForm.addEventListener('submit', this.searchSubmitHandler);
        }
    }

    private searchSubmitHandler = (e) => {
        e.preventDefault();
        (this.props as any).history.push('/search?q=' + this.searchField.value);
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Header.tsx